import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Spinner = styled.div`
	border: 0.2em solid rgba(0, 0, 0, 0.1);
	border-top: 0.2em solid #767676;
	border-radius: 50%;
	width: 2.28571429rem;
	height: 2.28571429rem;
	animation: ${spin} 0.6s linear infinite;
	margin: auto;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	transform: -webkit-translate(-50%, -50%);
	transform: -moz-translate(-50%, -50%);
	transform: -ms-translate(-50%, -50%);
`;

interface DataParam {
	minHeight?: string;
}

export const LoaderLayout = styled.div<DataParam>`
	width: 100%;
	height: 100%;
	min-height: ${({ minHeight }) => (minHeight !== '' ? minHeight : '200px')};
`;

export const Loader: React.FC<DataParam> = (props) => {
	const { minHeight = '' } = props;
	return (
		<>
			<LoaderLayout minHeight={minHeight} style={{ display: 'flex', alignItems: 'center' }}>
				<Spinner />
			</LoaderLayout>
		</>
	);
};

export default Loader;
